import { Link } from 'react-router-dom'
import { GitBranch, FileText, Wrench, Activity, Files, Database, Play } from 'lucide-react'

const tiles = [
  { to: '/studio/artifacts', icon: Files, label: 'Artifacts',
    desc: 'Browse, search, sort, filter every artifact in the system. Bulk-run pipeline, ignore noise.' },
  { to: '/studio/pipeline', icon: GitBranch, label: 'Pipeline',
    desc: 'DAG editor — add steps, set dependencies, watch the cascade.' },
  { to: '/studio/pipeline-test', icon: Play, label: 'Test run',
    desc: 'Walk one artifact through the DAG one step at a time, against the real LLM, with no production-state writes.' },
  { to: '/studio/prompts', icon: FileText, label: 'Prompts',
    desc: 'Author prompts, dry-run against artifacts, compare versions, promote to production.' },
  { to: '/studio/test-sets', icon: Wrench, label: 'Test sets',
    desc: 'Curated bundles of artifacts to validate prompt changes against expected outputs.' },
  { to: '/studio/observability', icon: Activity, label: 'Observability',
    desc: 'LLM call log, audit log, run history.' },
  { to: '/studio/imports', icon: Database, label: 'Imports',
    desc: 'Pull artifacts from the v1 raw tables into a tenant.' },
]

export default function StudioIndex() {
  return (
    <div className="me-scroll mx-auto max-w-4xl overflow-auto p-8">
      <h1 className="text-[20px] font-semibold me-text">Prompt Studio</h1>
      <p className="mt-2 text-[13px] me-text-dim">
        Workspace for designing the AI workflow that powers Matter Engine — pipeline DAG, prompt content,
        test artifacts, observability. Separate from the attorney-facing workspace by design.
      </p>

      <div className="mt-8 grid grid-cols-2 gap-3">
        {tiles.map(({ to, icon: Icon, label, desc }) => (
          <Link
            key={to}
            to={to}
            className="me-card p-5 transition hover:border-[color:var(--me-borderStrong)]"
          >
            <div className="mb-2 flex items-center gap-2">
              <Icon size={16} className="me-text-mute" />
              <span className="text-[14px] font-medium me-text">{label}</span>
            </div>
            <div className="text-[12px] me-text-mute leading-relaxed">{desc}</div>
          </Link>
        ))}
      </div>
    </div>
  )
}
